export const DATA_HOOKS = {
  noGroups: 'no-groups',
  noGroupsResult: 'no-groups-result',
  noGroupsCreateButton: 'no-groups-create-group-button',
};
